import { isSuperAdminUser } from './userRoles';
import { hasSeenLanding } from './landingVisitStorage';

export const REGISTRATION_TYPES = [
  { value: 'corporate', label: 'Corporate' },
  { value: 'policy_maker', label: 'Policy Maker' },
];

export function formatRegistrationTypeLabel(registrationType) {
  const match = REGISTRATION_TYPES.find((t) => t.value === registrationType);
  return match?.label || registrationType || '—';
}

export function workspacePathForRegistrationType(registrationType) {
  if (registrationType === 'policy_maker') return '/policy-makers/alerts';
  if (registrationType === 'corporate') return '/corporate/alerts';
  return '/';
}

/**
 * Post-login home:
 *  - Super Admin → landing page (persona chooser).
 *  - Corporate / Policy Maker on first visit → landing page (with Continue button).
 *  - Corporate / Policy Maker on subsequent visits → their alerts dashboard.
 */
export function homePathForUser(user) {
  if (!user) return '/';
  if (isSuperAdminUser(user)) return '/';
  if (!hasSeenLanding(user)) return '/';
  return workspacePathForRegistrationType(user.registration_type);
}
